import { SetupAccountScreen } from './SetupAccountScreen';
import { ConfirmEmailScreen } from './ConfirmEmailScreen';
import { ForgotPasswordScreen } from './ForgotPasswordScreen';
import { ResetPasswordScreen } from './ResetPasswordScreen';

/**
 * Routing manual de rutas de auth PÚBLICAS (v1.3.1 + v1.3.2).
 * Mismo patrón que `/legal/*`: se montan FUERA de AuthProvider (ver App.tsx)
 * → sin sesión ni TenantInterceptor. Sin react-router; navegación vía anchors.
 */
export const SETUP_ACCOUNT_PATH = '/auth/setup-account';
export const CONFIRM_EMAIL_PATH = '/auth/confirm-email';
export const FORGOT_PASSWORD_PATH = '/auth/forgot-password';
export const RESET_PASSWORD_PATH = '/auth/reset-password';

export function isPublicAuthRoute(pathname: string): boolean {
  const p = pathname.replace(/\/+$/, '');
  return (
    p === SETUP_ACCOUNT_PATH ||
    p === CONFIRM_EMAIL_PATH ||
    p === FORGOT_PASSWORD_PATH ||
    p === RESET_PASSWORD_PATH
  );
}

export function PublicAuthRouter() {
  const p = window.location.pathname.replace(/\/+$/, '');
  if (p === CONFIRM_EMAIL_PATH) return <ConfirmEmailScreen />;
  if (p === SETUP_ACCOUNT_PATH) return <SetupAccountScreen />;
  if (p === RESET_PASSWORD_PATH) return <ResetPasswordScreen />;
  if (p === FORGOT_PASSWORD_PATH) return <ForgotPasswordScreen />;
  return null;
}